// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.19e06eca',
  revision: '19e06eca',
  branch: 'develop',
  date: 'Mon, 20 Apr 2026 16:30:34 GMT'
};